import { api } from "./client.js";
export const midnightRunsApi = {
    list: () => api.get("api/midnight-runs").json(),
    detail: (runDate) => api.get(`api/midnight-runs/${runDate}`).json(),
};
